import { useState, useEffect } from 'react';
import './veilleur.css';
import { useVeilleurClock } from './Useveilleurclock';
import VueEntree      from './Vueentree';
import VueListe       from './Vueliste';
import VueSignalement from './Vuesignalement';
import VueRecherche   from './Vuerecherche';

import MobileDrawer from '../Mobile/MobileDrawer'
import {NAV_RONDE,NavIcon,LogoutIcon,BurgerIcon,ShieldIcon,SunIcon,MoonIcon,WarnIcon}  from '../Icons/icons'
import {ModalUrgence} from '../Urgence/ModalUrgence'
import SidebarContent  from './SideBar';
import VueRonde from './Vueronde'

// ── Hook: gestion du thème ─────────────────────────────
function useTheme() {
  const [theme, setTheme] = useState(
    () => localStorage.getItem('pg_theme') || 'dark'
  );
  const toggle = () => {
    setTheme(prev => {
      const next = prev === 'dark' ? 'light' : 'dark';
      localStorage.setItem('pg_theme', next);
      return next;
    });
  };
  return { theme, toggle };
}


export default function VeilleurView({ user, onLogout }) {
  const { time, date }               = useVeilleurClock();
  const { theme, toggle: toggleTheme } = useTheme();
  const [activeView,  setActiveView]  = useState('entree');
  const [showUrgence, setShowUrgence] = useState(false);
  const [drawerOpen,  setDrawerOpen]  = useState(false);
 
  const currentUser = user ?? { nom: 'Karim Amara', initiales: 'KA' };
 
  /* Naviguer + fermer le drawer en même temps */
  const handleNavigate = (viewId) => {
    setActiveView(viewId);
    setDrawerOpen(false);
  };
 


const renderView = () => {
    switch (activeView) {
      case 'entree':      return <VueEntree      onSuccess={() => setActiveView('liste')} />;
      case 'liste':       return <VueListe />;
      case 'signalement': return <VueSignalement onSuccess={() => setActiveView('liste')} />;
      case 'recherche':   return <VueRecherche />;
      case 'ronde':       return <VueRonde />;
      default:            return <VueEntree />;
    }
  };
 
  return (
    <div className="vv-app" data-theme={theme}>
 
      {/* ══ TOPBAR ══ */}
      <header className="vv-topbar">
 
        {/* Burger — visible uniquement sur mobile (≤768px) */}
        <button
          className="vv-burger"
          onClick={() => setDrawerOpen(true)}
          aria-label="Ouvrir le menu"
          aria-expanded={drawerOpen}
        >
          <BurgerIcon />
        </button>
 
        {/* Logo */}
        <div className="vv-logo">
          <ShieldIcon />
          PARK<span>GUARD</span>
        </div>
 
        {/* Desktop uniquement */}
        <div className="vv-divider vv-desktop-only" />
        <div className="vv-badge vv-desktop-only">
          <span className="vv-badge-dot" />
          Service actif
        </div>
 
        {/* Horloge */}
        <div className="vv-clock">{time}</div>
        <span className="vv-date vv-desktop-only">{date}</span>
 
        {/* Bouton urgence */}
        {/* Toggle thème sombre / clair */}
        <button
          className="vv-theme-btn"
          onClick={toggleTheme}
          aria-label={theme === 'dark' ? 'Passer en mode clair' : 'Passer en mode sombre'}
          title={theme === 'dark' ? 'Mode clair' : 'Mode sombre'}
        >
          {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
        </button>
 
        <button className="vv-btn-urgence" onClick={() => setShowUrgence(true)}>
          <WarnIcon />
          <span className="vv-urgence-txt">URGENCE</span>
        </button>
      </header>
 
      {/* ══ BODY ══ */}
      <div className="vv-body">
 
        {/* Sidebar — desktop uniquement */}
        <aside className="vv-sidebar">
          <SidebarContent
            activeView={activeView}
            onNavigate={handleNavigate}
            currentUser={currentUser}
            onLogout={onLogout}
          />
        </aside>
 
        {/* Main */}
        <main className="vv-main">
          {renderView()}
        </main>
      </div>
 
      {/* ══ DRAWER MOBILE ══ */}
      <MobileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <SidebarContent
          activeView={activeView}
          onNavigate={handleNavigate}
          currentUser={currentUser}
          onLogout={onLogout}
        />
      </MobileDrawer>
 
      {/* ══ MODAL URGENCE ══ */}
      {showUrgence && <ModalUrgence onClose={() => setShowUrgence(false)} />}
    </div>
  );
}